import BlankLayout from "components/Layouts/blank";
import HomeLayout from "components/Layouts/home";
import { ROUTES } from "helpers/routes";
import CheckIn from "pages/check-in";
import CompanyDetails from "pages/company";
import Home from "pages/home";
import SelectTopic from "pages/select-topic";
import ThankYou from "pages/thank-you";
import UpdateMyInfo from "pages/update-my-info";
import { Navigate, Route, Routes } from "react-router-dom";

export const AppRoutes = () => (
  <Routes>
    <Route path={ROUTES.HOME} element={<HomeLayout />}>
      <Route index element={<Navigate to={ROUTES.COMPANIES} replace />} />
      <Route path={ROUTES.COMPANIES} element={<Home />}>
        <Route path={ROUTES.COMPANY_DETAILS} element={<CompanyDetails />} />
      </Route>
    </Route>
    <Route
      path={ROUTES.CHECK_IN}
      element={
        <BlankLayout title="Check-in Page">
          <CheckIn />
        </BlankLayout>
      }
    />
    <Route
      path={ROUTES.SELECT_TOPIC}
      element={
        <BlankLayout title="What do you want to explore?">
          <SelectTopic />
        </BlankLayout>
      }
    />
    <Route
      path={ROUTES.THANK_YOU}
      element={
        <BlankLayout>
          <ThankYou />
        </BlankLayout>
      }
    />
    <Route
      path={ROUTES.UPDATE_MY_INFO}
      element={
        <BlankLayout title="Update information">
          <UpdateMyInfo />
        </BlankLayout>
      }
    />
  </Routes>
);
